import { UseQueryOptions, useQuery } from '@tanstack/react-query'

import { getImportRequestsVerification } from 'services/import-requests'
import { ImportRequestQueryKeys } from 'services/import-requests/queryKeys'
import type {
  GetImportRequestsVerificationParams,
  GetImportRequestsVerificationResponse
} from 'services/import-requests/types'

export const useGetImportRequestsVerification = (
  params: GetImportRequestsVerificationParams,
  options?: Omit<UseQueryOptions<GetImportRequestsVerificationResponse, Error>, 'queryKey'>
) => {
  return useQuery<GetImportRequestsVerificationResponse, Error>({
    ...options,
    queryKey: ImportRequestQueryKeys.VerificationList(params),
    queryFn: ({ signal }) => getImportRequestsVerification(params, { signal })
  })
}
